import Cookies from 'js-cookie';

import router from '@/router/index';
import store from '@/store';
import { getToken,setToken,removeToken } from '@/utils/auth';
import NProgress from 'nprogress'; // 进度条

import i18n from '@/lang'; // Internationalization

import Message from '@/components/message/message';
let msgBox = Message.install;
let msgBoxFn = function(msg,closeTime){
	msgBox({
		content:i18n.vm.messages[i18n.locale]['BACKENDMSG'][msg],
		timeOut:closeTime,
		isClose:false,
		type:'error',
	});
}

const whiteList = ['/login','/signup','/forget','/404','/notice','/about','/shareFoorprints','/shareAchievement','/resetPassword','/changeMail','/wechatBind']; // 不重定向白名单
router.beforeEach((to,from,next)=>{
	// NProgress.start();
	document.getElementById('app').scrollTo(0,0);
	let nowPath = '/'+to.path.split('/')[1];
	
	//微信挂载重定向
	if(nowPath == '/redirectByUrl'){
		if(to.params.to && to.params.token){
			// console.log(to.params.to,to.params.token)
			store.dispatch('SetToken',to.params.token);
			next({
				path:`/${to.params.to.replace("@","/")}`,
			});
		}else{
			msgBoxFn('REDIRECT_UNFOUND',2000,'/404');
			store.dispatch('FedLogOut').then(()=>{
				next({
					path:'/404',
				});
			});
		}
		// NProgress.done();
	}else{
		//正常登陆
		if(getToken()){
			if(to.path === '/login'){
				next({
					path:'/index',
				});
				// NProgress.done();
			}else{
				store.dispatch('GetUserInfo').then((res)=>{
					i18n.locale = res.data.LANG;
					Cookies.set('language',res.data.LANG);
					next();
				}).catch((err)=>{
					if(whiteList.indexOf(nowPath) !== -1){
						next();
					}else{
						msgBoxFn('DIFFERENT_TOKEN',2000);
						store.dispatch('FedLogOut').then(()=>{
							next({
								path:'/login',
							});
						});
					}
				});
			}
		}else{
			if(whiteList.indexOf(nowPath) !== -1){ // 在免登录白名单，直接进入
				next();
			}else if(nowPath == '/record' && to.params.id){
				let data = {
					ID:to.params.id,
					TYPE:'unrecorded'
				}
				store.dispatch('Redirect',data).then((res)=>{
					if(res.msgType === ""){
						next(`/record/${to.params.id}`);
					}else{
						msgBoxFn('REDIRECT_UNFOUND',2000,'/404');
						store.dispatch('FedLogOut').then(()=>{
							next({
								path:'/404',
							});
						});
					}
				}).catch((err)=>{
					msgBoxFn('REDIRECT_UNFOUND',2000,'/404');
					store.dispatch('FedLogOut').then(()=>{
						next({
							path:'/404',
						});
					});
				});
				// NProgress.done();
			}else{
				next({
					path:'/login',
				});
				// 否则全部重定向到登录页
				// NProgress.done();
			}
		}
	}
	
});

router.afterEach((to,from,next)=>{
	// 标题页动态多语言标题
	let title =  `「${i18n.vm.messages[i18n.locale]['tm']}」`;
	if(to.name){
		let pageName = i18n.vm.messages[i18n.locale][`_${to.name}`]['title'] || '';
		title += `- ${pageName}`;
	}
	document.title = title;
});



// WEBPACK FOOTER //
// ./src/permission.js